export interface IFinanzaDetallePagoEnLinea {
    IdFolio: number;
    /** Ej: "OVEJA26-000294" */
    Description: string;
    Card: {
        Type: CFinanzaDetallePagoEnLineaTipoTarjeta;
    }
}

export enum CFinanzaDetallePagoEnLineaTipoTarjeta {
    Debito = "debit",
    Credito = "credit"
}